import * as React from "react";

// icons
import "font-awesome/css/font-awesome.min.css";

// styling
import "bootstrap/dist/css/bootstrap.min.css";
import "./assessmentViewPage.scss";

// toast
import "react-toastify/dist/ReactToastify.css";

// flags
import "flag-icon-css/css/flag-icon.css";

// modal video
import ModalVideo from "react-modal-video";

// services
import {
  clearSessionData,
  currentBaseUrl,
  currentUser,
  getGeneralSmartTableData,
  isBasicPreassessmentDone,
  isHomeScreenDisabled,
  isUserLoggedIn,
  isUserUpgraded
} from "../../common/services";

// components
import Loader from "react-loader";
import NavBar from "../../components/CustomNav/CustomNav.Component";
import SvgDisplay from "../../common/svgDisplay";
import BadgesDisplay from "../../common/badgesDisplay.Component";
import StudentStory from "../../common/studentStory.Component";
import Enquiry from "../../common/enquiries.Component";
import CustomSingleSpeedo from "../../common/customSingleSpeedo.Component";

// router
import { Redirect } from "react-router-dom";

// toast component
import { toast, ToastContainer } from "react-toastify";

// react calendar css
import "react-big-calendar/lib/css/react-big-calendar.css";

// tabs
import { Col, Row } from "reactstrap";

// component css
import "./assessmentViewPage.css";
import { CSSTransition } from "react-transition-group";
import PerceptionsTile from "../../common/perceptionsTile.Component";
import TraitTile from "../../common/traitTile.Component";
import ResponsesTile from "../../common/responsesTile.Component";
import withServices from 'src/HOCs/withServices';

class AssessmentResultPage extends React.Component<any, any> {
  public state = {
    activeTab: "1",
    currentNavlink: "1",
    assessmentinfo: {} as any,
    baseurl: currentBaseUrl(),
    badges: [],
    cardbutton: {
      borderRadius: 10,
      fontSize: 11,
      margin: 3,
      marginBottom: 7,
      marginTop: 14
    },
    currentgroup: 0,
    destination: "",
    gaugescore: 1,
    gaugewidth: 0,
    groups: [] as any[],
    height: 0,
    infofields: {
      id: "id"
    },
    loaded: false,
    mounted: false,
    navigate: false,
    resultfields: {
      info: "assessment_info",
      results: "results"
    },
    ticks: [
      { label: "&&&&Severe Alert", value: 0 },
      { label: "High Alert", value: 3 },
      { label: "Moderate Alert", value: 5 },
      { label: "Low Alert", value: 7.5 },
      { label: "No Alert", value: 9 }
    ],
    toDataCenter: false,
    tologin: false,
    topreassessment: false,
    toProfile: false,
    username: "",
    width: 0,
    isUserUpgraded: isUserUpgraded(),
    toHelpCenter: false,
    isVidModalOpen: false,
    videoLink: ""
  };

  constructor(props) {
    super(props);
    this.onLogout = this.onLogout.bind(this);
    this.setTab = this.setTab.bind(this);
    this.openWidget = this.openWidget.bind(this);
    this.onProfile = this.onProfile.bind(this);
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
    this.handleGenSmartDataLoaded = this.handleGenSmartDataLoaded.bind(this);
    // this.nextgroup =  this.nextgroup.bind(this);
    // this.prevgroup =  this.prevgroup.bind(this);
    this.goToDataCenter = this.goToDataCenter.bind(this);
    this.openVideoModal = this.openVideoModal.bind(this);
    this.closeVideoModal = this.closeVideoModal.bind(this);
    this.handleOpenModal = this.handleOpenModal.bind(this);
    this.toHelpCenter = this.toHelpCenter.bind(this);
  }

  public goToDataCenter() {
    this.setState({ toDataCenter: true });
    console.log("data center");
  }

  public toHelpCenter() {
    this.setState({ toHelpCenter: true });
  }

  public onProfile(arg) {
    console.log("profile in Parent", arg);
    this.setState({ toProfile: true });
  }

  public handleAssessmentInfoLoaded(res) {
    if (res.code === 200) {
      console.log(res.response);
      // this.setState({loaded: true});
      getGeneralSmartTableData(
        "admin/assessments/" +
          res.response[this.state.infofields.id] +
          "/completed_assessment/",
        text => this.handleAssessmentResultsLoaded(text)
      );
    } else if (res.code === 401) {
      this.onLogout("arg");
    }
  }

  public handleAssessmentResultsLoaded(res) {
    if (res.code === 200) {
      // console.log("responseloaded:", res.response);
      this.setState({ loaded: true });
      this.setState({ assessmentinfo: res.response });

      let qgroups = [] as any[];

      if (res.response[this.state.resultfields.results]) {
        const responses = this.state.assessmentinfo[
          this.state.resultfields.results
        ].responses;

        for (const row of responses) {
          qgroups.push(row.Group);
          console.log("GROUPS: " + row.Group);
        }

        qgroups = Array.from(new Set(qgroups));

        this.setState({ groups: qgroups });
      }
    }

    if (res.code === 401) {
      this.onLogout("arg");
    }
  }

  // to make the gauge component responsive
  public updateWindowDimensions() {
    const diff = window.innerWidth * 0.6;
    this.setState({
      width: window.innerWidth,
      height: window.innerHeight,
      gaugewidth: diff
    });
  }

  public onLogout(arg) {
    console.log("Logout in Parent", arg);
    this.setState({ tologin: true });
  }

  public setTab(param, e) {
    this.setState({
      activeTab: param,
      currentNavlink: param
    });
  }

  public currentid() {
    const key1 = "match";
    return this.props[key1].params.id;
  }

  public chosendesiignation() {
    const key1 = "match";
    return this.props[key1].params.designation;
  }

  public openWidget(param, e) {
    console.log("widget: " + param);
    this.setState({ destination: currentBaseUrl() + param });
    console.log("Widget COmplete URL: " + currentBaseUrl() + " " + param);
    this.setState({ navigate: true });
  }

  public onChange(arg) {
    console.log("On change", arg);
  }

  public onRowClick(event, { rowData, rowIndex, tableData }) {
    const { title } = rowData;
    console.log(title);
  }

  public componentWillUnmount() {
    window.removeEventListener("resize", this.updateWindowDimensions);
  }

  public componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener("resize", this.updateWindowDimensions);

    if (!isUserLoggedIn()) {
      this.setState({ tologin: true });
    } else {
      this.setState({ username: currentUser() });

      if (!isBasicPreassessmentDone()) {
        this.setState({ topreassessment: true });
        console.log("go to preassessment");
      } else {
        // redirect only to preugrade results
        if (!isUserUpgraded()) {
          if (isHomeScreenDisabled()) {
            clearSessionData();
          }
          getGeneralSmartTableData(
            "admin/assessments/get_user_preassessment_details/",
            text => this.handleAssessmentInfoLoaded(text)
          );
        }

        // allow on page
        else {
          console.log("f");
        }
      }
    }
    getGeneralSmartTableData(
      "admin/badge_allocations/achievement_summary/",
      text => this.handleGenSmartDataLoaded("badges", "badges", text)
    );
    this.setState({ mounted: true });
  }

  public handleGenSmartDataLoaded(key, objkey, res) {
    if (res.code === 200) {
      console.log("THE KEY IS " + key);
      this.setState({ loaded: true });
      this.setState({ [key]: res.response[objkey] });
    }
    if (res.code === 401) {
      this.onLogout("arg");
    }
  }

  public booleanText(bool) {
    if (bool) {
      return (
        <p>
          <i className="fa fa-check" />
        </p>
      );
    } else {
      return (
        <p>
          <i className="fa fa-ban" />
        </p>
      );
    }
  }

  public displayPerceptions() {
    if (this.state.assessmentinfo.results) {
      console.log(
        "PerceptionsData " +
          this.state.assessmentinfo[this.state.resultfields.results]
      );
      return <PerceptionsTile results={this.state.assessmentinfo.results} services={this.props.services} />;
    } else {
      return <Loader />;
    }
  }

  public getPerceptions() {
    return (
      <div className="perceptions-container">
       
        {this.displayPerceptions()}

        <div className="see-all">
          <button className="see-all-btn blue-button">See all results</button>
        </div>
      </div>
    );
  }

  public getResponses() {
    if (this.state.assessmentinfo.results) {
      return (
        <ResponsesTile responseData={this.state.assessmentinfo.results} />
      );
    } else {
      return <Loader />;
    }
  }

  public svgInfo() {
    if (this.state.assessmentinfo[this.state.resultfields.results]) {
      return (
        <Row className="svg-card">
          {/* SVG display expects two props, totalLessons and completed lessons */}
          {/* <SvgDisplay /> */}

          <Row
            className="progress-detail-preupgrade"
            style={{ marginBottom: "0px" }}
          >
            <Col
              lg="4"
              xs="6"
              sm="6"
              xl="4"
              md="4"
              className=" order-xl-1 order-lg-1  order-sm-1 order-xs-1 order-md-1"
            >
              <p className="motivation" style={{ opacity: 0 }}>
                <span>Progress & Attainment Pack</span> <br />
                This plan is personalised to you so <br /> we strongly recommend
                you go for it
              </p>
            </Col>
            <Col
              xs="12"
              md="4"
              lg="4"
              sm="12"
              xl="4"
              className="order-xl-2 order-lg-2 order-sm-3 order-xs-3 order-md-2"
            >
              <button
                className="upgrade-suggested-plan green-button"
                onClick={this.openWidget.bind(this, "packages")}
              >
                Upgrade <br />{" "}
                <p style={{ fontSize: ".3em" }}>
                  Based on the results <br />
                  here's our suggested <br /> plan of action for you
                </p>
              </button>
            </Col>
            <Col
              lg="4"
              xs="6"
              sm="6"
              xl="4"
              md="4"
              className="order-xl-3 order-lg-3 order-sm-2 order-xs-2 order-md-3"
            >
              <p className="next-stop" style={{ opacity: 0 }}>
                <span>
                  Next Stop <span>Upgrade</span>
                </span>{" "}
                <br /> If however you would like to explore our other packages,{" "}
                <span style={{ color: "#acff24" }}>Please Click Here</span>{" "}
                <br />
              </p>
            </Col>
          </Row>
        </Row>
      );
    } else {
      return <Loader />;
    }
  }

  public risklevelTitle() {
    if (this.state.assessmentinfo[this.state.resultfields.results]) {
      return (
        <Col xs="12" sm="12" md="12" lg="8" xl="8" className="card-intro">
          <h4 className="assessment-header">
            {
              this.state.assessmentinfo[this.state.resultfields.results]
                .RiskLevel
            }
            :{" "}
            {
              this.state.assessmentinfo[this.state.resultfields.results]
                .TraitTitle
            }
          </h4>
          <div className="top-content">
            <p>
              {
                this.state.assessmentinfo[this.state.resultfields.results]
                  .TraitCopy
              }
            </p>
          </div>
          <div className="bottom-content">
            <button
              className="blue-button watch-video"
              onClick={this.openVideoModal.bind(this, "X69QMZOKbo0")}
            >
              Watch a video explaining the results
            </button>
          </div>
        </Col>
      );
    } else {
      return <Loader />;
    }
  }

  public textInfo() {
    if (this.state.assessmentinfo[this.state.resultfields.results]) {
      return (
        <Col xs="12" sm="12" md="12" lg="4" xl="4">
          <CustomSingleSpeedo
            assessmentValue={Math.round(
              this.state.assessmentinfo[this.state.resultfields.results]
                .PLOAScore
            )}
            alertLevel ={this.state.assessmentinfo[this.state.resultfields.results].RiskLevel}
            backgroundColor="#1a1a1a"
            color="#acff24"
          />
        </Col>
      );
    } else {
      return <div />;
    }
  }
  public handleOpenModal(event) {
    this.openVideoModal(event.target.value);
  }

  public openVideoModal(vidLink) {
    this.setState({ isVidModalOpen: true, videoLink: vidLink });
  }

  public closeVideoModal() {
    this.setState({ videoLink: "", isVidModalOpen: false });
  }

  public render() {
    if (this.state.tologin === true) {
      return <Redirect to="/login" />;
    }

    // if (!isUserLoggedIn()) {
    //   return <Redirect to="/login" />;
    // }

    if (this.state.toDataCenter) {
      return <Redirect to={this.state.baseurl + "datacenter"} />;
    }

    if (this.state.navigate === true) {
      return <Redirect to={this.state.destination} />;
    }

    if (this.state.toProfile === true) {
      return <Redirect to={this.state.baseurl + "profile"} />;
    }

    if (this.state.topreassessment === true) {
      // return <Redirect to={this.state.baseurl + "assessment/0"} />;
      return <Redirect to={this.state.baseurl + "preassessmentguide"} />;
    }

    if (this.state.toHelpCenter) {
      return <Redirect to="/helpcenter" />;
    }

    return (
      <div>
        <NavBar logoutParent={this.onLogout} profileParent={this.onProfile} />
        <CSSTransition in={true} appear={true} classNames="fade" timeout={800}>
          <Row className="align-items-center">
            <div className="assessmentresult-container">
              <ModalVideo
                channel="youtube"
                isOpen={this.state.isVidModalOpen}
                onClose={this.closeVideoModal}
                videoId={this.state.videoLink}
              />

              <div className="top-after-bar">
                <h4 className="welcome-message">
                  Hi {this.state.username}, <span>Great Work</span> in <br />{" "}
                  Completing the assessment
                </h4>
                <button
                  className="upgrade green-button"
                  onClick={this.openWidget.bind(this, "packages")}
                >
                  Upgrade
                  <br />
                  Now!
                </button>
              </div>

              {/* <p className="results-title">{this.chosendesiignation()} assessment results</p> */}

              <Row className="result-card">
                {this.textInfo()}
                {this.risklevelTitle()}
              </Row>

              {/* <h4 className="results-title"> Plan to progress</h4> */}

              {/* {this.svgInfo()} */}

              {/* badges */}
              <div className="badges-container">
                <h4 className="results-title" style={{ marginTop: "7em" }}>
                  MY ACHIEVEMENTS
                </h4>
                <BadgesDisplay
                  userUpgraded={this.state.isUserUpgraded}
                  badges={this.state.badges}
                  idkey="id"
                  namekey="Name"
                  earnedkey="Earned"
                  onClickUpgrade = {this.openWidget.bind(this, "packages")}

                />
              </div>

              <div className="assessment-summary">
                  <div className="perceptions-container">

                    {this.displayPerceptions()}

                    <div className="see-all">
                      <button
                        className="blue-button see-all-btn"
                        onClick={this.goToDataCenter}
                      >
                        See all results
                      </button>
                    </div>
                  </div>
                  {this.getResponses()}
              </div>

              <Row />

              <Row
                style={{
                  width: "100%",
                  height: "auto",
                  alignItems: "center",
                  marginTop: "4em"
                }}
              >
                <Col xl="6" lg="12" md="12" sm="12">
                  <StudentStory openModal={this.handleOpenModal} />
                </Col>
                <Col xl="6" lg="6" md="12" sm="12">
                  <Enquiry toHelpCenter={this.toHelpCenter} />
                </Col>
                {/* <Col xl="3" lg="6" md="12" sm="6">
                  <Enquiry />
                </Col> */}
              </Row>
            </div>
          </Row>
        </CSSTransition>
      </div>
    );
  }
}

export default withServices(AssessmentResultPage);



// WEBPACK FOOTER //
// ./src/pages/Assessments/assessmentResult.Component.tsx